module.exports = __webpack_public_path__ + "img/25.8521c0b1.jpg";